import { IHikingTimezoneDTO } from '../@types/hiking.backendTypes';
import { IHikingTimezone } from '../@types/hiking.baseTypes';

export const mapHikingTimezoneItem = (backData: IHikingTimezoneDTO): IHikingTimezone => {
  return {
    id: +backData.id,
    date_in: new Date(backData.date_in),
    date_out: new Date(backData.date_out),
    timezone: backData.timezone,
    comment: backData.comment,
    created: {
      id: +backData.creator_id,
      name: backData.creator_name,
      date: new Date(backData.created_at),
    },
    updated:
      backData.updated_id && backData.updated_at && backData.updated_name
        ? {
            id: +backData.updated_id,
            name: backData.updated_name,
            date: new Date(backData.updated_at),
          }
        : null,
  };
};
